import React from 'react';

import { Flex, SvgIcon, Image, Text } from 'Components/Base';
import { useConfig } from 'Context/ConfigContext';

const Loading = () => {
  const { global: globalConfig } = useConfig();
  const loadingType = globalConfig?.loading?.type;
  const imageUrl = globalConfig?.loading?.imageUrl;

  if (loadingType === 'IMAGE') {
    return (
      <Flex
        height={'100%'}
        flex={1}
        alignItems={'center'}
        justifyContent={'center'}
        flexDirection={'column'}
      >
        {imageUrl && <Image src={imageUrl} width={'48px'} />}
        <Text color={'greyscale.grey3'} mt={imageUrl ? 2 : 0}>
          กำลังโหลด...
        </Text>
      </Flex>
    );
  }

  return (
    <Flex height={'100%'} flex={1} alignItems={'center'} justifyContent={'center'}>
      <SvgIcon color={'primary'} icon={SvgIcon.ICON_LIST.LOADING} />
    </Flex>
  );
};

export default Loading;
